import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Controller, useController, useFormContext, get } from 'react-hook-form';

const SelectFieldCustom = (props) => {
    const { meta } = useController(props);
    const { trigger, formState } = useFormContext();
    const error = get(formState.errors, props.name);
    const errorText = meta.invalid ? error?.message : '';
    const { name, items, label, required = false, onSelectedChange } = props;
    return (
        <FormControl
            variant="outlined"
            style={{ minWidth: '100%' }}
            size="small"
            error={!!errorText}>
            <InputLabel>{label}</InputLabel>
            <Controller
                name={name}
                render={({ onChange, value, name }) => (
                    <Select
                        onChange={(e) => {
                            onChange(e);
                            trigger(name);
                            if (onSelectedChange) onSelectedChange(e);
                        }}
                        value={value ? value : ''}
                        name={name}>
                        {items?.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </Select>
                )}
                label={label}
                required={required}
                defaultValue={props.defaultValue}
            />
            <FormHelperText>{errorText}</FormHelperText>
        </FormControl>
    );
};

export default SelectFieldCustom;
